import { isIOSDevice } from './isIOSDevice';

export const fixBodyScroll = () => {
  const body = document.querySelector('body')!;

  if (!isIOSDevice()) {
    body.style.overflow = 'hidden';
  }

  if (isIOSDevice()) {
    const currentScroll = window.scrollY;
    body.style.position = 'fixed';
    body.style.left = '0px';
    body.style.right = '0px';
    body.style.top = `-${currentScroll}px`;
    body.style.bottom = '0px';

    body.setAttribute('data-scroll-offset', `${currentScroll}`);
  }
};
